import { Button, Empty, Flex, Link, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { ScanProgressEmptyTable } from "@/molecules/EmptyTable"

import styles from "./EmptyWidget.module.scss"

import type { EmptyWidgetProps } from "./EmptyWidget.types"

export const EmptyWidget = (props: EmptyWidgetProps) => {
  const {
    count,
    total,
    to,
    actions,
    children,
    text,
    shouldHideScanProgressEmptyTable
  } = props
  const showChildren = !!count && !!total
  const showEmpty =
    !showChildren && (!!total || shouldHideScanProgressEmptyTable)
  const showProgress =
    !showChildren && !showEmpty && !shouldHideScanProgressEmptyTable
  const showLink = to || actions
  const { t } = useTranslation()
  const { t: tEmpty } = useTranslation("translation", {
    keyPrefix: "dashboard.empty.noIssues"
  })
  const triageText = t("navigation.triage")

  return (
    <Flex vertical flex={1} align="center" className={styles.container}>
      {showChildren && children}
      {showProgress && <ScanProgressEmptyTable />}
      {showEmpty && (
        <Empty
          rootClassName={styles.root}
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <Flex vertical>
              <Text strong type="secondary">
                {tEmpty("1")}
              </Text>
              {showLink && (
                <Flex gap={4} align="center" justify="center">
                  <Text type="secondary">{tEmpty("2")}</Text>
                  {to && <Link to={to}>{triageText}</Link>}
                  {actions && (
                    <Button
                      type="link"
                      size="small"
                      className={styles.button}
                      onClick={() => actions.redirectToTriage()}
                    >
                      {triageText}
                    </Button>
                  )}
                </Flex>
              )}
              <Text type="secondary">{text || tEmpty("3")}</Text>
            </Flex>
          }
        />
      )}
    </Flex>
  )
}
